/**
 *
 * @param delay number of milliseconds to delay, default 0
 * @returns
 */
export async function sleep(delay = 0): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, delay))
}
